import CryptoJs from 'crypto-js'

export const decrypt = (value) => {

    try {
        
        const key = CryptoJs.enc.Base64.parse(process.env.REACT_APP_ENCRYPT_KEY);
        const iv = CryptoJs.enc.Base64.parse(process.env.REACT_APP_DECRYPT_KEY);
        const decipher = CryptoJs.AES.decrypt(value, {key:key}, { iv : iv});
        const decrypted = decipher.toString(CryptoJs.enc.Utf8);

        if (!decrypted) {
            throw new Error("Decryption failed or returned an empty string");
        }

        return decrypted;
    } catch (error) {
        return null; // Or however you wish to handle errors
    }
};
